"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACKING_DEBOUNCE_MS = exports.USER_ACTION_LAUNCHED_ADDON_MODAL = exports.USER_ACTION_FIELD_UPDATED = void 0;
// event name when a field is updated
exports.USER_ACTION_FIELD_UPDATED = 'user_action.field_updated';
// event name when an addon modal is launched
exports.USER_ACTION_LAUNCHED_ADDON_MODAL = 'user_action.launched_addon_modal';
// debounce updated fields for 2s to avoid excessive track calls,
// should not affect UI responsiveness, only analytics
exports.TRACKING_DEBOUNCE_MS = 2000;
//# sourceMappingURL=tracking.js.map